
import { createTheme, responsiveFontSizes } from '@mui/material/styles';

// A custom theme for this app

const theme = createTheme({

    palette: {
        mode: 'light',
        // Set the color mode to 'light' or 'dark'
        primary: {
            main: '#36175d',
        },
        secondary: {
            main: '#19857b',
        },
    },
    components: {

        MuiAppBar: {
            styleOverrides: {
                positionFixed: ({ ownerState, theme }) => ({
                    display: 'flex',
                    color: "#000",
                    width: `calc(100% - ${theme.mixins.drawerWidth}px)`,
                    backgroundColor: '#fff',
                    padding:"0px 10px",
                    [theme.breakpoints.down('sm')]: {
                        height: '135px',
                    },
                    [theme.breakpoints.down('md')]: {
                        width: `100%`,
                    },
                    [theme.breakpoints.up('sm')]: {
                        height: '95px',
                    },
                    [theme.breakpoints.up('lg')]: {
                        height: '55px',
                        justifyContent: 'center',
                        alignItems: 'center',

                    },
                    // Example custom background color


                }),
            },
        },
        MuiDrawer: {
            styleOverrides: {
                paper: ({ ownerState, theme }) => ({
                    ...(ownerState.variant === 'permanent' && {
                        display: 'none',
                        boxSizing: "border-box",
                        width: `${theme.mixins.drawerWidth}px`, //ownerState.open ? `${theme.mixins.minimizeDrawer}px` : `${theme.mixins.drawerWidth}px`,
                        color: "#fff", // Your custom styles here
                        backgroundImage: "linear-gradient(123deg, #fff, #fff)",
                        [theme.breakpoints.up('md')]: {
                            display: 'block',
                        } // Example custom background color
                    }),
                    ...(
                        ownerState.variant === 'temporary' && {
                            // Styles for the outlined variant
                            display: 'block',
                            boxSizing: "border-box",
                            width: '250px',
                            color: "#fff", // Your custom styles here
                            backgroundImage: "linear-gradient(123deg, #fff, #fff)",
                            [theme.breakpoints.up('md')]: {
                                display: 'none',
                            }
                        }

                    ),
                }),
            },
        },

        MuiBox: {
            styleOverrides: {
                title: {
                    border: "1px dashed #ff6060",
                    backgroundColor: "#fff0f0",
                    padding: "10px",
                    textAlign: "center"
                },
            }

        },
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                contained: {
                    backgroundImage: "linear-gradient(180deg, #36175d, #36175d)",
                    border: "1x solid #36175d",
                    '&:hover': {
                        backgroundImage: 'linear-gradient(180deg, #36175d, #36175d)', // New background color on hover
                        opacity: "0.8",
                    },
                },

                green: {
                    backgroundColor: "green",
                    color: 'white',
                    '&:hover': {
                        backgroundColor: 'green', // New background color on hover
                        opacity: "0.8",

                    },
                },

                yellow: {
                    backgroundColor: "#f0ad4e",
                    color: 'white',
                    '&:hover': {
                        backgroundColor: '#f0ad4e', // New background color on hover
                        opacity: "0.8",

                    },
                },
                white: {
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    color: "#333",

                    '&:hover': {
                        backgroundColor: '#fff5f5', // New background color on hover
                        opacity: "0.8",

                    },
                },
                toolBarIconButton: {
                    minWidth: "0px",
                    padding: "2px 3px",
                    backgroundColor: "#36175d",
                    color: "#fff",
                    '&:hover': {
                        backgroundColor: '#fedf1e', 
                        opacity: "0.8"
                    },
                },
                slectPlanBtn: {
                    backgroundColor: "#36175d",
                    minWidth: "0px",
                    color: "#fff",
                    padding: "0px",
                    borderRadius: "10px",
                    '&:hover': {
                        backgroundColor: '#36175d', // New background color on hover
                        opacity: "0.8"
                    },

                },
                smartCollectCardBtn: {
                    color: "#fff",
                    position: "absolute",
                    left: 8,
                    bottom: 22,
                    zIndex: 1,
                    backgroundColor: "#36175d",
                    '&:hover': {
                        backgroundColor: '#36175d', // New background color on hover
                        opacity: "0.8"
                    },


                },
                productPageCardBtn: {
                    color: "",
                    position: "absolute",
                    left: 0,
                    bottom: 28,
                    zIndex: 1,
                    backgroundColor: " #fff",
                    '&:hover': {
                        backgroundColor: '#fff', // New background color on hover
                        opacity: "0.8"
                    },

                },
                prepaidBtn: {
                    borderWidth: "1px",
                    borderStyle: "solid none solid solid",
                    borderRadius: "5px 0px 0px 5px",
                    borderColor: "#556CD680",
                    color: "#36175d",

                },
                postpaidBtn: {
                    borderWidth: "1px",
                    borderStyle: "solid",
                    borderRadius: "0px",
                    borderColor: "#556CD680",
                    color: "#36175d",

                },
                refetchBalance: {
                    borderWidth: "1px",
                    borderStyle: "solid solid solid none",
                    borderRadius: "0px 5px 5px 0px",
                    borderColor: "#556CD680",
                    color: "#36175d",
                },
                addDeleteBank: {
                    // Styles for the outlined variant
                    backgroundColor: "",
                    border: "none",
                    color: "#36175d",
                    '&:hover': {
                        backgroundColor: '', // New background color on hover
                        opacity: "0.8",
                        border: "none",

                    },
                }


            },

        },
        MuiMenu: {
            styleOverrides: {
                root: {
                    overflow: 'scroll',
                    marginTop: '0.5rem',

                },
            },
        },

        MuiInputBase: {
            styleOverrides: {

                input: ({ ownerState }) => ({
                    ...(
                        ownerState.readOnly === true && ownerState.variant === "border" ? {
                            // Styles for the contained variant
                            backgroundColor: '#fff',
                            color: 'black',
                            borderRadius: 4,
                            height: '16px',
                            padding: '10px',
                            borderWidth: '1px',
                            fontSize: "16px",
                            fontWeight: 400,
                            borderStyle: "solid",
                            borderColor: '#ced4da'
                        } : ownerState.readOnly === true ? {
                            backgroundColor: '#fff',
                            color: 'black',
                            borderRadius: 4,
                            height: '16px',
                            padding: '10px',
                            borderWidth: '1px',
                            fontSize: "16px",
                            fontWeight: 400,
                            borderStyle: "none none solid none",
                            borderColor: '#ced4da'
                        } :
                                {

                                    color: 'black',
                                    borderRadius: 4,
                                    height: '16px',
                                    padding: '10px',
                                    backgroundColor: '#fff',
                                    borderWidth: '1px',
                                    borderColor: "#ced4da",
                                    borderStyle: "solid",
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    '&:focus': {
                                        borderColor: '#36175d',
                                        boxShadow: '0 0 0 0.2rem #556CD640',
                                    }
                                    // ... Other styles
                                })
                }),
            },
            variants: [

                {
                    props: { variant: 'textInput' },
                    style: {
                        width: "100%",
                    },
                },
                {
                    props: { variant: 'border' },
                    style: {
                        width: "100%",
                    },
                },
            ]

        },

        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: '#36175d',
                    cursor: 'pointer'
                },
            },
            variants: [

                {
                    props: { variant: 'btnIcon' },
                    style: {
                        color: "#fff"
                    },
                },
                {
                    props: { variant: 'reportProblem' },
                    style: {
                        color: "#36175d",
                        fontSize: "110px"
                    },
                },

                {
                    props: { variant: 'done' },
                    style: {
                        color: "green",
                        border: "1px solid green",
                        fontSize: "45px"
                    },
                },
                {
                    props: { variant: 'pending' },
                    style: {
                        color: "#d1ae10",
                        border: "1px solid #d1ae10",
                        fontSize: "45px"
                    },
                },
                {
                    props: { variant: 'failed' },
                    style: {
                        color: "red",
                        border: "1px solid red",
                        fontSize: "45px"
                    },
                },
                {
                    props: { variant: 'profile' },
                    style: {
                        color: "#36175d",

                        fontSize: "40px"
                    },
                },



            ],
        },

        MuiTypography: {
            styleOverrides: {
            },


            variants: [
                {
                    props: { variant: 'menuLabel' },
                    style: {
                        fontWeight: 700,
                        fontSize: "13px",
                    },
                },

                {
                    props: { variant: 'rechargeInfo' },
                    style: {
                        fontWeight: 500,
                        fontSize: "12px",
                    },
                },
                {
                    props: { variant: 'mandatory' },
                    style: {
                        color: "red",
                        fontSize: "14px",
                    },
                },
                {
                    props: { variant: 'error' },
                    style: {
                        color: "red",
                        fontSize: "14px",
                        display:"block"
                    },
                },
                {
                    props: { variant: 'bold' },
                    style: {

                        fontWeight: 500
                    },
                },
                {
                    props: { variant: 'customh1' },
                    style: {
                        fontSize: "32px",
                        fontWeight: 600,
                        display: 'block'
                    },
                },

                {
                    props: { variant: 'customh2' },
                    style: {
                        fontSize: "22px",
                        fontWeight: 600,
                        display: 'block'
                    },
                },
                {
                    props: { variant: 'customh3' },
                    style: {
                        fontSize: "18px",
                        fontWeight: 600,
                        display: 'block'
                    },
                },
                {
                    props: { variant: 'customh4' },
                    style: {
                        fontSize: "16px",
                        fontWeight: 600,
                        display: 'block'
                    },
                },
                {
                    props: { variant: 'coloredh4' },
                    style: {
                        fontSize: "16px",
                        fontWeight: 600,
                        display: 'block',
                        color: "#36175d"
                    },
                },
                {
                    props: { variant: 'coloredh5' },
                    style: {
                        fontSize: "14px",
                        fontWeight: 600,
                        display: 'block',
                        color: "#36175d"
                    },
                },
                {
                    props: { variant: 'coloredh6' },
                    style: {
                        color: "#36175d",
                        fontSize: "13px",
                        fontWeight: 500,
                        textAlign: "center"
                    },
                },
                {
                    props: { variant: 'white' },
                    style: {

                        color: '#fff',
                        fontWeight: 'bold',
                        display: "block",

                    },
                },
                {
                    props: { variant: 'print' },
                    style: {
                        fontSize: "13px",
                        fontWeight: 400,

                    },
                },
                {
                    props: { variant: 'viewNetwork' },
                    style: {
                        fontSize: "23px",
                        textAlign: 'center',


                    },
                },
                {
                    props: { variant: 'printNetwork' },
                    style: {
                        fontSize: "18px",
                        textAlign: 'center',


                    },
                },


            ],
        },
        MuiCard: {
            styleOverrides: {

            },
            variants: [

                {
                    props: { variant: 'inventory' },
                    style: {
                        backgroundColor: "#36175d",
                        height: "100px"

                    },
                },
                {
                    props: { variant: 'userCard_selected' },
                    style: {
                        border: "1px solid #36175d",
                        height: "180px",
                        overflow: "auto",
                        backgroundColor: "#36175d",
                        color: "#fff"

                    },
                },
                {
                    props: { variant: 'userCard' },
                    style: {
                        border: "1px solid #36175d",
                        height: "180px",
                        overflow: "auto"
                    },
                },
                {
                    props: { variant: 'products' },
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "5px",
                        borderRadius: "5px",
                        height: "160px",
                        cursor: "pointer",
                        border: "1px solid #36175d",
                        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.19), 0 1px 1px 0 rgba(0, 0, 0, 0.19)",
                        width: "100%",
                        "&:hover": {
                            border: "1px solid #36175d",
                            transform: "translateY(-6px)",
                            boxShadow: "-2px 10px 13px 4px #23439f6b",
                        }

                    },
                },

                {
                    props: { variant: 'menuCards' },
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "5px",
                        borderRadius: "15px",
                        height: "130px",
                        cursor: "pointer",
                        border: "1px solid #36175d",
                        boxShadow: "0 1px 1px 0 rgba(0, 0, 0, 0.19), 0 1px 1px 0 rgba(0, 0, 0, 0.19)",
                        width: "100%",
                        "&:hover": {
                            boxShadow: "0px 0px 21px 3px #ccc"
                        }
                    },
                },
                {
                    props: { variant: 'smartCollectVPA' },
                    style: {
                        backgroundImage:"linear-gradient(117deg, #36175d, #36175d)",
                        maxWidth: "440px",
                        borderRadius: "20px",
                        position: "relative",
                        height: " 232px",
                        width: " 400px",
                        "&:after": {
                            content: '""',
                            position: "absolute",
                            width: "205px",
                            height: "185px",
                            background: "rgb(255 255 255 / 22%)",
                            left: -30,
                            bottom: -30,
                            borderRadius: "50%"
                        }
                    },
                },
                {
                    props: { variant: 'smartCollectBank' },
                    style: {
                        backgroundImage: "linear-gradient(117deg, #36175d, #36175d)",
                        maxWidth: "440px",
                        borderRadius: "20px",
                        position: "relative",
                        height: " 232px",
                        width: " 400px",
                        "&:after": {
                            content: '""',
                            position: "absolute",
                            width: "205px",
                            height: "185px",
                            background: "rgb(255 255 255 / 22%)",
                            left: -30,
                            bottom: -30,
                            borderRadius: "50%"
                        }
                    },
                },
            ]
        },

        MuiCardMedia: {
            styleOverrides: {
            },
            variants: [

                {
                    props: { variant: 'smartCollectLogo' },
                    style: {
                        display:"none",
                        width: "45px",
                        height: "35px",
                        position: "absolute",
                        top: 10,
                        right: 25,
                    },
                },

                {
                    props: { variant: 'smartCollectCardLogo' },
                    style: {
                        width: "85px",
                        height: "72px",
                        position: "absolute",
                        top: "40%",
                        left: "40%",
                    },
                },
            ]
        },

        MuiCardHeader: {
            styleOverrides: {

                title: {
                    color: '#fff',
                }

            },
        },



        MuiTable: {
            styleOverrides: {

                root: {
                    border: '1px solid #b7b5b5',
                    borderCollapse: 'collapse',
                    padding: '0px',
                    whiteSpace: "nowrap",
                }

            },
        },

        MuiTableContainer: {
            styleOverrides: {

                root: {
                    maxHeight: " 440px",
                    overflowX: "auto"
                }

            },
        },

        MuiTableCell: {
            styleOverrides: {
                root: {
                    border: '1px solid #b7b5b5',
                    padding: '6px',
                    fontSize: '14px',
                },
                head: {

                }
            },
        },
        MuiTableRow: {
            styleOverrides: {

                root: {
                    '&:nth-of-type(odd)': {
                        backgroundColor: "#f7f5fc",
                    },
                },
            },
        },
        MuiList: {
            variants: [

                {
                    props: { variant: 'term_conditon' },
                    style: {
                       
                        listStyleType: "none",
                        overflow: "hidden",
                        padding: "2px 26px"
                    },
                },
            ]
        },

        MuiListItem: {
            variants: [

                {
                    props: { variant: 'termList' },
                    style: {
                        display: "inline",
                    },
                },
            ]
        },
        MuiLink: {
            styleOverrides: {

            },
            variants: [

                {
                    props: { variant: 'link' },
                    style: {
                        color: "#36175d",
                        textDecoration: "none",
                        fontSize: "13px"
                    },
                },
            ]
        }


    },
    mixins: {
        minimizeDrawer: 70, // Example value for minimizeDrawer
        drawerWidth: 250, // Example value for drawerWidth
    },

});



export default responsiveFontSizes(theme);
